import { follow, unFollow, queryFollowStatus, followUserBatch } from './src/follow';
import { qqkdFollow, qqkdUnFollow, qqkdQueryFollowStatus } from './src/qqkdFollow';

export default {
  follow,
  unFollow,
  queryFollowStatus,
  followUserBatch,
  qqkdFollow,
  qqkdUnFollow,
  qqkdQueryFollowStatus,
};
